import landBatchRestService from '../services/landBatch/landBatchRestService'
import locationRestService from '../services/location/LocationRestService'
import landBatchUtil from '../services/landBatch/landBatchUtilsFunctions'

const state = {
  landBatches: [],
  batchesByLocation: [],
  selectedItem: {},
  defaultLandBatch: {
    id: -1,
    name: '',
    haAmount: '',
    parentId: '',
    note: ''
  }
}

const getters = {
  getLandBatches: state => state.landBatches,
  getBatchesByLocation: state => state.batchesByLocation,
  getSelectedItem: state => state.selectedItem,
  getDefaultLandBatch: state => state.defaultLandBatch
}

const actions = {
  async getLandBatches (context) {
    try {
      let data = await landBatchRestService.getLandBatches()
      context.commit('setLandBatches', data)
    } catch (e) {
      console.log('Error fetching Land Batches')
    }
  },
  async getBatchesByLocation (context) {
    try {
      let data = await locationRestService.getBatchesByLocation()
      context.commit('setLandBatchesByLocation', data)
    } catch (e) {
      console.log('Error fetching Land Batches')
    }
  },
  async saveLandBatch (context, landBatch) {
    let snackBarContent = {actived: true, message: 'Lote Agregado/Modificado Exitosamente.', color: 'success'}
    try {
      await landBatchRestService.saveLandBatch(landBatch)
    } catch (e) {
      snackBarContent = {actived: true, message: 'Error Agregado/Modificado Lote.', color: 'error'}
    }
    context.commit('setSnackBarStatus', snackBarContent, {root: true})
  },
  async removeLandBatch (context, id) {
    let snackBarContent = {actived: true, message: 'Lote Eliminado Exitosamente.', color: 'success'}
    try {
      await landBatchRestService.removeLandBatch(id)
      context.commit('setSnackBarStatus', snackBarContent, {root: true})
    } catch (error) {
      if (error.response.status === 424) {
        let notiDialogValue = {
          actived: true,
          title: 'Imposible borrar el item seleccionado',
          body: landBatchUtil.getDependenciesMsg(error.response.data) }
        context.commit('setNotificationDialog', notiDialogValue, {root: true})
      } else {
        snackBarContent = {actived: true, message: 'Error Eliminando Lugar.', color: 'error'}
        context.commit('setSnackBarStatus', snackBarContent, {root: true})
      }
    }
  },
  setSelectedItem (context, selectedItem) {
    context.commit('setSelectedItem', selectedItem)
  }
}

const mutations = {
  setLandBatches (state, data) {
    state.landBatches = data
  },
  setLandBatchesByLocation (state, data) {
    state.batchesByLocation = data
  },
  setSelectedItem (state, selectedItem) {
    state.selectedItem = selectedItem
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
